module.exports = __webpack_public_path__ + "img/img_web06_banner1.9668f1eb.jpg";